import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ai-apps/$appId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/ai-apps/$appId/dashboard",
      params,
    });
  },
});
